import { RecommendLotsController } from './controllers/RecommendLotsController.js';
import { PublicationsController } from '../publication/controllers/PublicationsController.js';
import { PublicationsDiscussingController } from '../publication/controllers/PublicationsDiscussingController.js';
import { BasePage } from '../../base/BasePage.js';

export class LotsPage extends BasePage {
    constructor() {

        super();


        const token = window.appData?.token;
        const locale = window.appData?.locale;
        const auctionId = window.appData?.auctionId;
        const sectionId = window.appData?.sectionId;
        const viewerId = window.appData?.viewerId;
        const clientCurrencyId = window.appData?.clientCurrencyId;
        const cp = window.appData?.cp;

        this.initResource({
            controller: new RecommendLotsController(),
            event: 'lots.recommend',
            cacheKey: `lots.recommend.${cp}`,
            payload: { token, locale, auctionId, sectionId, viewerId, clientCurrencyId }
        });

        this.initResource({
            controller: new PublicationsController(),
            event: 'publication.getAll',
            cacheKey: `publication.getAll.${cp}`,
            payload: { token, locale, auctionId, sectionId, viewerId }
        });

        this.initResource({
            controller: new PublicationsDiscussingController(),
            event: 'publication.getMostDiscussed',
            cacheKey: `publication.getMostDiscussed.${cp}`,
            payload: { token, locale, viewerId }
        });
    }
}